import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Training from "@/components/Training";
import AIReadiness from "@/components/AIReadiness";
import Metrics from "@/components/Metrics";
import Resources from "@/components/Resources";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import AnimatedBackground from "@/components/AnimatedBackground";

export default function ConsultingPage() {
  return (
    <>
      <AnimatedBackground />
      <div className="relative" style={{ zIndex: 1 }}>
        <Navbar />
        <Hero />
        <div className="section-divider" />
        <Services />
        <div className="section-divider" />
        <Training />
        <div className="section-divider" />
        <AIReadiness />
        <div className="section-divider" />
        <Metrics />
        <div className="section-divider" />
        <Resources />
        <div className="section-divider" />
        <ContactForm />
        <Footer />
      </div>
    </>
  );
}
